import { render, staticRenderFns } from "./Concejo.vue?vue&type=template&id=4e214b93&scoped=true"
import script from "./Concejo.vue?vue&type=script&lang=ts"
export * from "./Concejo.vue?vue&type=script&lang=ts"
import style0 from "./Concejo.vue?vue&type=style&index=0&id=4e214b93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e214b93",
  null
  
)

export default component.exports